﻿import type { Environment } from "../../network/domain/Environment";
import { computed, makeObservable } from "mobx";
import type { GetEnvironmentAndCountryInfoResponse } from "../../network/responses/GetEnvironmentAndCountryInfoResponse";

export interface IEnvironmentStore {
	currentEnvironment: Environment | null;
	otherEnvironments: Environment[];
	allEnvironments: Environment[];
}

export class EnvironmentStore implements IEnvironmentStore {
	public currentEnvironment: Environment | null = null;
	public otherEnvironments: Environment[] = [];

	constructor(getEnvironmentAndCountryInfoResponse: GetEnvironmentAndCountryInfoResponse) {
		makeObservable(this);

		this.currentEnvironment = getEnvironmentAndCountryInfoResponse.currentEnvironment;
		this.otherEnvironments = getEnvironmentAndCountryInfoResponse.otherEnvironments?.filter(x => !x.inactive) ?? [];
	}

	@computed
	public get allEnvironments(): Environment[] {
		if (this.currentEnvironment === null) return this.otherEnvironments;
		return [this.currentEnvironment, ...this.otherEnvironments];
	}
}
